import { Module } from 'vuex';
import { IDocument } from '@/types/Document';
import { RootState } from '@/store/store';
import { mutations } from '@/dealroom/template-library/store/template-library.mutations';
import { actions } from '@/dealroom/template-library/store/template-library.actions';
import { IFolder } from '@/folders/types/folder';
import { IFolderTree } from '@/folders/types/folder-tree';

export const namespace = 'templateLibrary';

export interface ITemplateLibraryPagination {
  search: string;
  limit: number;
  offset: number;
  currentPageIndex: number;
}

export interface ITemplateLibraryState {
  loading: boolean;
  loaded: boolean;
  folderId: string;
  templates: IDocument[];
  folders: IFolder[];
  folderTree: IFolderTree;
  breadcrumbs: IFolder[];
  pagination: ITemplateLibraryPagination;
  totalCount: number;
}

const state: ITemplateLibraryState = {
  loading: false,
  loaded: false,
  folderId: undefined,
  templates: [],
  folders: [],
  folderTree: null,
  breadcrumbs: [],
  totalCount: 0,
  pagination: {
    search: null,
    limit: 8,
    offset: 0,
    currentPageIndex: 0,
  },
};

export const templateLibrary: Module<ITemplateLibraryState, RootState> = {
  state,
  actions,
  mutations,
  namespaced: true,
};
